import { Link } from "react-router-dom";

export function Brand({ size = "lg", withTagline = true, className = "" }) {
  const sizes = {
    sm: "text-3xl",
    md: "text-4xl sm:text-5xl",
    lg: "text-5xl sm:text-6xl lg:text-7xl",
  };
  return (
    <Link to="/" className={`block text-center ${className}`} data-testid="brand-logo-link">
      <div className={`brand-logo whitespace-nowrap ${sizes[size]}`}>FUN-NASTIX</div>
      {withTagline && (
        <div className="font-display text-primary/80 text-base sm:text-lg mt-1 whitespace-nowrap">
          Keeping Fit, Having Fun, Gymnastics is for Everyone!
        </div>
      )}
    </Link>
  );
}
